import nodelistToArray from '../utils/nodelist_to_array';

export default class ElementAdapter {
  static parseHTML(html = "<null/>"){
    var doc;

    doc = document.implementation.createHTMLDocument();
    doc.body.innerHTML = html;

    return doc.body.children[0];
  }

  constructor(tagName){
    var el;

    if (tagName instanceof Element) {
      el = tagName;
    } else {
      el = document.createElement(tagName);
    }

    this._el = el;
  }

  el(){
    return this._el;
  }

  querySelector(selector){
    var result = this.el().querySelector(selector);
    return result && (new ElementAdapter(result));
  }

  getAttribute(attrName){
    return this.el().getAttribute(attrName);
  }

  setAttribute(attrName, attrValue){
    this.el().setAttribute(attrName, attrValue);
  }

  tagName(){
    return this.el().tagName;
  }

  className(className){
    if (typeof className === "undefined") {
      return this.el().className;
    } else {
      this.el().className = className;
    }
  }

  appendChild(child){
    if (child instanceof Element) {
      this.el().appendChild(child);
    } else {
      this.el().appendChild(child.el());
    }
  }

  removeChild(child) {
    if (child.length) {
      const arr_child = nodelistToArray(child);
      arr_child.forEach(_child => {
        _child.parentElement.removeChild(_child);
      });
    } else {
      child.parentElement.removeChild(child);
    }
  }

  children(){
    return this.el().children;
  }

  addClass(className){
    if (this.el().classList){
      this.el().classList.add(className);
    } else {
      this._el.className += ' ' + className;
    }
  }

  removeClass(className){
    if (this.el().classList){
      this.el().classList.remove(className);
    } else {
      this._el.className = this._el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }

  hasClass(className){
    return new RegExp('(^| )' + className + '( |$)', 'gi').test(this._el.className);
  }

  innerText(string){
    if(typeof string !== "undefined"){
      this.el().textContent = string;
      this.el().innerText = string;
    } else {
      return this.el().textContent || this.el().innerText;
    }
  }

  parentElement() {
    return new ElementAdapter(this.el().parentElement);
  }

  clientHeight() {
    return this.el().clientHeight;
  }

  clientWidth() {
    return this.el().clientWidth;
  }
}
